export default __webpack_public_path__ + "static/media/contact_details.c03968c8.svg";